import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  PopUpManager,
  WizBaseCollector,
  WizBasePopUp,
  WizCheckbox,
  WizDatasource,
  WizDropItemEvent,
  WizList,
  WizPopUp,
  WizVgroup,
  WizEventManager, WizEvent,
  WizTranslationManager,
  WizHgroup
} from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { FIELD_KIND, FeiKeyDef, WizConstants } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';


import { FreedataHeaderEditPop } from '../../freedatas/pops/freedata-header-edit.pop';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { ALK_EVENT_TYPE, WIDGET_KIND } from '../../../../model/enums';
import { ViewData } from '../../../../model/view.data';
import { FreedataArgsVO } from '../../../../vo/core/freedataargs.vo';
import { Model } from '../../../../model/model';
import { FreedataEditItemRenderer } from './freedata-edit-item.renderer';
import { PivotGroupEditItemRenderer } from '../../pivot/renderers/settings/pivot-groupedit-item.renderer';
import { HeaderGroupEditPop } from '../../pivot/renderers/header/header-groupedit.pop';
import { widgetHeaderVO } from '../../pivot/renderers/header/header-editext.pop';


@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'freedata-settings-pop',
  templateUrl: './freedata-settings.pop.html',
})
export class FreedataSettingsPop extends WizBasePopUp {
  // liste des champs et mesures disponibles
  @ViewChild('freeList', { read: WizList }) freeList: WizList;
  /** le composant de filtre principal */
  @ViewChild('mainFilter', { read: FilterComponent })
  mainFilter: FilterComponent;
  // zone globale des listes
  @ViewChild('vgDetailZone', { read: WizHgroup, static: false })
  vgDetailZone: WizHgroup;

  @ViewChild('lstFilter', { read: WizList }) lstFilter: WizList; // liste des champs de filtre
  @ViewChild('lstRow', { read: WizList }) lstRow: WizList; // liste des champs en ligne
  @ViewChild('lstGroup', { read: WizList }) lstGroup: WizList; // liste des groupes de colonne


  @ViewChild('cbShowDeleteCol', { read: WizCheckbox }) cbShowDeleteCol: WizCheckbox; // cb d'affichage de la colonne delete
  @ViewChild('cbShowSelectCol', { read: WizCheckbox }) cbShowSelectCol: WizCheckbox; // cb d'affichage de la colonne select
  @ViewChild('cbSelectUnique', { read: WizCheckbox }) cbSelectUnique: WizCheckbox; // cb sélection unique

  // dimensions demandées
  public static width: string = '1000px';
  public static height: string = 'calc(100% - 81px)';


  /** Renderer de la liste */
  public renderer: any = FreedataEditItemRenderer;

  public get widget(): IFreedataWidget {
    return this.datas;
  }

  public get model(): Model {
    return this.widget.model;
  }

  public dataSource: WizDatasource<PivotField> = null; // DS des champs disponibles (au step)

  public filterDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public rowDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();

  protected context: WidgetConfigurationObj; // la configuration
  protected updateCallback: Function; // la callback pour retour et traitement dans le pivotComponent

  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  protected fieldPop: WizPopUp; // la popUp d'édition des champs
  protected groupFieldPop: WizPopUp; // la popUp d'édition des groupes de colonnes


  
  public popUpMode: WIDGET_KIND = WIDGET_KIND.GRID; // le mode de cette pop, pour alimenter les PKD
  

  /** autoriser la zone de drop de filtres et la col de sélection */
  // public get useGridFunctions(): boolean {
  //   return this.widget?.widgetKind === WIDGET_KIND.FD_GRID;
  // }

  constructor(public elementRef: ElementRef) {
    super();
  }

  show(): void {

    this.context = cloneDeep(this.widget.context); 
    this.updateCallback = this.widget.backFromSettingsPop.bind(this.widget);

    const filter = []; // alimentation du filtre de la DS principale

    this.mainFilter.configure(['code', 'labelOrDefaultLabel'], null, Array.from(filter)).build();

    const parts: string[] = this.context.fdk.split(ViewData.CONTEXT_SEPARATOR); // on split sur #
    const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(parts[0]);
    
    const dataDS: PivotField[] = [];
    args.forEach((fda: FreedataArgsVO) => {
      const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
      wcio.fdvf = fda.code;
      // par défaut, pas éditable
      // wcio.ro = true;
      dataDS.push(new PivotField(this.widget, wcio, null, fda));
    });

    // ajout du fake pour mettre un filtre générique
    let wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.cod = ViewData.FILTER_GENERIC;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.filter.$');
    const fakeFilter: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeFilter.order = -1;
    dataDS.push(fakeFilter);

    // ajout du fake pour mettre un filtre me
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.cod = ViewData.FILTER_ME;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.filter.me.$');
    const fakeMeFilter: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeMeFilter.order = -1;
    dataDS.push(fakeMeFilter);


    this.dataSource = new WizDatasource<PivotField>(dataDS)
    .setItemCodeField('code')
    .setSelectionMode('none')
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }, { property: 'trsLabel', way: 'asc', numeric: false }])
    .setFilter(this.filterFunc.bind(this))
    .build();


    // alimentation des collections depuis le contexte
    const preFilterArr: PivotField[] = [];
    const preRowArr:PivotField[] = [];
    const preGroupArr: PivotField[] = [];


    this.context.r.forEach((confItem: WidgetConfigurationItemObj) => {
      // utiliser code pour le FD, fdvf pour le champ
      let field: string = confItem.fdvf.split(WizConstants.FD_PARTS_SEPARATOR)[0];
      const fake = this.dataSource.getItemByKey(field);
      if (!!fake)  {
        const ff: PivotField = new PivotField(this.widget, confItem, null, fake.arg);
        ff.usedAsRow = true;
        ff.pinned = confItem.pin; // reprise des informations de pin
        preRowArr.push(ff);
      }
        
    });
  
    this.context.f.forEach((confItem: WidgetConfigurationItemObj) => {
      
      let fake = null;
      if(confItem.cod === ViewData.FILTER_GENERIC) {
          const ff: PivotField = new PivotField(this.widget, confItem, null, null);
          preFilterArr.push(ff);
      } else if(confItem.cod === ViewData.FILTER_ME) {
          const ff: PivotField = new PivotField(this.widget, confItem, null, null);
          preFilterArr.push(ff);
      } else {
        let field: string = confItem.fdvf.split(WizConstants.FD_PARTS_SEPARATOR)[0];
       fake = this.dataSource.getItemByKey(field);
        if (!!fake)  {
          const ff: PivotField = new PivotField(this.widget, confItem, null, fake.arg);
          ff.usedAsFilter = true;
          preFilterArr.push(ff);
        }
      }
    });

    this.context.g?.forEach((confItem: WidgetConfigurationItemObj) => {
      preGroupArr.push(this.model.widgetEngine.generateGroupEntry(this.widget, this.groupDS.getSource().length, confItem));
    });  

    this.filterDS.setSource(preFilterArr);
    this.rowDS.setSource(preRowArr);
    this.groupDS.setSource(preGroupArr);

    this.feedDatasources();
    this.addListeners();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.lstFilter.wizDataProvider = this.filterDS;
    // unicité de champs sur les filtres
    this.lstFilter.dropControlFunction = this.FilterDropControl.bind(this);

    // aucun contrôle sur rows et datas
    this.lstRow.wizDataProvider = this.rowDS;

    // ajout du transformer sur les zones cibles
    this.lstFilter.dropTransformFunction = this.fakeToFF.bind(this);
    this.lstRow.dropTransformFunction = this.fakeToFF.bind(this);

    this.lstGroup.wizDataProvider = this.groupDS;
    this.lstGroup.dropControlFunction = this.groupDropControl.bind(this);


    this.cbShowDeleteCol.wizChecked = !!this.context.shd;
    this.cbShowSelectCol.wizChecked = !!this.context.shs;
    this.cbSelectUnique.wizChecked = !!this.context.shsu;
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre de la DS principale
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DRAG_DROPPED, this.updateModel);
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DRAG_MOVED, this.updateModel);
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DELETE, this.updateModel);

    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, this.showConfPop); // demande de conf d'un champ
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_GROUP_FIELD, this.showGroupConfPop); // demande de conf d'un champ
  }

  /** validation du contenu */
  public doValid(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** modification du context pour retour sur la base des params */
  public updateContext(): void {
    // mémorisation du contexte de filtre
    const filterMap: Map<string, WidgetConfigurationItemObj> = new Map<string, WidgetConfigurationItemObj>();
    if (this.context.f) {
      this.context.f.forEach((wcio: WidgetConfigurationItemObj) => {
        if(wcio.cod === ViewData.FILTER_GENERIC) {
          filterMap.set(wcio.cod, wcio);
        } else if(wcio.cod === ViewData.FILTER_ME) {
          filterMap.set(wcio.cod, wcio);
        } else {
          filterMap.set(wcio.fdvf, wcio);
        }
        
      });
    }

    this.context.r = [];
    this.context.f = [];
    this.context.g = [];

    let idx: number = 1; // positions
    let confItem: WidgetConfigurationItemObj;
    this.rowDS.getSource().forEach((item: PivotField) => { // rows
      
      confItem = this.model.widgetEngine.newWcio(this.context.fdk, idx);
      confItem.lbl = item.label;
      // confItem.pin = item.fkd.pinned;
      confItem.pin = item.pinned; // fkd.pinned;
      
      confItem.fdvf = item.code; // TODO TODO @Field
      if(item.fdvSubField) {
        confItem.fdvf = [item.code, item.fdvSubField].join(WizConstants.FD_PARTS_SEPARATOR);
      }

      confItem.fdvSearch = item.fdvSearch; 
      confItem.heada = item.headerAlign;
      confItem.pgrp = item.parentGroup;
      confItem.cella = item.cellAlign;
      this.model.widgetEngine.wcioColParams(confItem, item.colRezisable, item.colMinSize, item.colSize, item.exportable, item.hiddenCol); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style, item.headerStyle, item.cellStyle); // format & style
      
      confItem.headInherit = item.headInherit;
      confItem.masterRowStyle = item.styleConso;
      confItem.cauto = item.colAutoSize;
      confItem.pmdexParams = item.pmdexParams;
      confItem.ro = item.readOnly;
      this.context.r.push(confItem);
      idx++;
    });

    this.filterDS.getSource().forEach((item: PivotField) => { // filters
      confItem = this.model.widgetEngine.newWcio(this.context.fdk, idx);
      confItem.fdvf = item.code; // TODO TODO @Field
      
      // injection du bon code pour les freeFilter (FREE & ME)
      if(item.code === ViewData.FILTER_GENERIC) {
        confItem.cod = ViewData.FILTER_GENERIC;
      } else if(item.code === ViewData.FILTER_ME) {
        confItem.cod = ViewData.FILTER_ME;
      }
      
      if(item.fdvSubField) {
        confItem.fdvf = [item.code, item.fdvSubField].join(WizConstants.FD_PARTS_SEPARATOR);
      }
      confItem.fdvSearch = item.fdvSearch; 
      confItem.lbl = item.label;
      confItem.filtHide = item.filtHide;
      confItem.filtOnEx = item.filtOnlyExist;
      this.model.widgetEngine.wcioColParams(confItem, false, item.colMinSize, item.colSize); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style); // format & style
      


      let realFilterCode: string = null;
      if(confItem.cod === ViewData.FILTER_GENERIC) {
        realFilterCode = ViewData.FILTER_GENERIC;
      } else if(confItem.cod === ViewData.FILTER_ME) {
        realFilterCode = ViewData.FILTER_ME;
      } else {
        realFilterCode = confItem.fdvf;
      }

      if (filterMap.has(realFilterCode)) { // reprise des filtres existants
        confItem.sel = filterMap.get(realFilterCode).sel;
        confItem.filtExp = filterMap.get(realFilterCode).filtExp;
      }

      this.context.f.push(confItem);
      idx++;
    });

    idx= 0;
    this.groupDS.getSource().forEach((item: PivotField) => { // colonnes custom
      confItem = this.model.widgetEngine.newWcio(item.code.split(ViewData.CONTEXT_SEPARATOR)[0], idx);
      confItem.lbl = item.labelOrDefaultLabel;
      confItem.hsty = item.headerStyle;
      confItem.pgrp = item.parentGroup;
      confItem.heada = item.headerAlign;
      confItem.cella = item.cellAlign;
      this.context.g.push(confItem);
      idx++;
    }); 


    this.context.shd = this.cbShowDeleteCol.wizChecked; // affichage du delete
    this.context.shs = this.cbShowSelectCol.wizChecked; // affichage du select
    this.context.shsu = this.cbSelectUnique.wizChecked; // affichage du select
  }

  public onHide() {
    if (this.doSaveFlag) {
      if (!!this.updateCallback) {
        this.updateContext();
        this.updateCallback(this.context);
      }
    }
  }

  /**
   * sur drop d'un FeiKeyDef, encapsulation en PivotField avant ajout à la DS
   * @param wbc la liste source
   * @param item l'objet draggé
   * @returns le pivotField
   */
  protected fakeToFF(wbc: WizBaseCollector, item: PivotField): PivotField {
    const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(item.contextItem.cod, 0);
    // wcio.ro = true; // readOnly par défaut
    const fake: FreedataArgsVO = item.arg;
    let result: PivotField = null;
    switch (wbc) {
      case this.lstFilter:
        result = new PivotField(this.widget, wcio, null, fake);
        result.usedAsFilter = true;
        // result.fdvField = result.code;
        break;
      case this.lstRow:
        result = new PivotField(this.widget, wcio, null, fake);
        // result.readOnly = true; // readOnly par défaut
        result.usedAsRow = true;
        result.fdvField = result.code;
        break;
    }
    return result;
  }

  /* ##############################################################################
                   filtre et rendu de la DS principale
     ############################################################################## */

  /**
   * modification du filtre
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.dataSource.refresh();
  }

  // filterFunc de la collection principale
  protected filterFunc(item: PivotField): boolean {
    return this.mainFilter.checkVisible(item);
  }

  /**
   * détection de la position des fields. Alimentation de la donnée sur dataSource (celle du FEI)
   * pour signaler les champs utilisés
   */
  protected checkFieldIsUsed(): void {
    // map pour les 4 collections
    const filterMap: Map<string, PivotField> = new Map(this.filterDS.getSource().map((item) => [item.fdvField, item]));
    const rowMap: Map<string, PivotField> = new Map(this.rowDS.getSource().map((item) => [item.fdvField, item]));

    this.dataSource.getSource().forEach((item:PivotField) => {
      item.usedAsFilter = filterMap.has(item.code);
      item.usedAsRow = rowMap.has(item.code);
    });
    this.dataSource.refresh();
  }

  /* ##############################################################################
                  modification du contenu de l'une des zones
    ############################################################################## */

  /**
   * Modification du modèle
   * @param e Evenement model change
   */
  protected updateModel(e: WizEvent): void {
    this.checkFieldIsUsed(); // synchro du rendu de la liste principale (icone oeil pour Used)
  }

  /**
   * demande d'affichage de la popUp de configuration des champs
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
  protected showConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( FreedataHeaderEditPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataHeaderEditPop.baseWidth + 'px',
      FreedataHeaderEditPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.fieldPop,
      fei: null,
      context: this.context,
      updateCallback: this.backFromFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: this.popUpMode,
      widget: this.widget,
      currentGroups: this.groupDS?.getSource()
    }

    // // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /**
   * retour d'édition de champ
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
  }

  /* ##############################################################################
                   contrôles de cohérence du drag'n'drop
     ############################################################################## */

  /** Fonction de controle du drop */
  public FilterDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;
    if (dragSource === this.lstFilter) {
      // déplacement self dans la liste de filtre
      return true; // on laisse passer
    }

    if(!!field.isFreeFilter) {
      for (const ff of this.filterDS.getSource()) {
        if (ff.code === field.code) {// une seule fois pour chaque filtre free
          return false;
        }
      }
      return true;
    }

    if (field.arg.dataType === FIELD_KIND.BINARY) { // pas les images
      return false;
    }

    // sinon, contrôle d'unicité du filtre
    for (const ff of this.filterDS.getSource()) {
      if (ff.code === field.code) {
        return false;
      }
    }
    return true;
  }



  /* ##############################################################################
                  gestion des groupes de colonnes custom en mode grid
    ############################################################################## */

  // les groupes de headers
  public groupDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public groupRenderer: any = PivotGroupEditItemRenderer;


  /** Fonction de controle du drop sur zone groupe de colonnes */
  public groupDropControl({ item, dragSource }: WizDropItemEvent): boolean {   
    if (dragSource === this.lstGroup) { // déplacement self
      return true; // on laisse passer
    }
    return false;
  }


  /** ajout d'un groupe de colonnes */
  public addGroup(): void {
    // console.log('addGroup');
    this.groupDS.addItem(this.model.widgetEngine.generateGroupEntry(this.widget, this.groupDS.getSource().length));
  }

  /**
   * demande d'affichage de la popUp de configuration des champs
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
   protected showGroupConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.groupFieldPop)) {
      // suppression de l'instance existante
      this.groupFieldPop.hide();
    }

    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.groupFieldPop = new WizPopUp( HeaderGroupEditPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      HeaderGroupEditPop.baseWidth + 'px',
      HeaderGroupEditPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.groupFieldPop,
      fei: this.widget.fakeFei,
      context: this.context,
      updateCallback: this.backFromGroupFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: this.popUpMode,
      widget: this.widget,
      currentGroups: this.groupDS?.getSource()
    }

    // alimentation des datas
    this.groupFieldPop.datas = datas;

    this.groupFieldPop.show();
  }

  /**
   * retour d'édition de groupe de colonnes
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromGroupFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
    this.lstRow.wizDataProvider.refresh();
  }



}
